exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-dropdown{border:none;box-shadow:0 4px 6px rgba(0,0,0,.3);padding:10px 30px;z-index:2}.d-dropdown+.backdrop,.d-dropdown::-webkit-backdrop{background-color:transparent}.d-dropdown+.backdrop,.d-dropdown::backdrop{background-color:transparent}.d-dropdown .d-dropdown-heading{color:rgba(53,59,68,.5);font-size:14px;font-weight:700;line-height:24px;margin:0}.d-dropdown .d-dropdown-heading:not(:first-child){margin-top:10px}", ""]);

// exports
